module.exports = __webpack_public_path__ + "assets/create.03317ab8.svg";